// Этот файл генерируется автоматически, его не следует редактировать вручную
import block1Animation from '@/widgets/block1Animation.js';
import cinemagraphScroll from '@/widgets/cinemagraphScroll.js';
import datesGame from '@/widgets/datesGame.js';
import globalEventButton from '@/widgets/globalEventButton.js';
import hoverParentClass from '@/widgets/hoverParentClass.js';
import iNeverGame from '@/widgets/iNeverGame.js';
import loopingAnimation from '@/widgets/loopingAnimation.js';
import openByGlobalEvents from '@/widgets/openByGlobalEvents.js';
import playVideo from '@/widgets/playVideo.js';
import playlist from '@/widgets/playlist.js';
import playlistsCarousel from '@/widgets/playlistsCarousel.js';
import shareCurrentUrl from '@/widgets/shareCurrentUrl.js';
import spriteAnimation from '@/widgets/spriteAnimation.js';
import stopClickPropagation from '@/widgets/stopClickPropagation.js';

export default {
  'block1Animation': async () => { return { default: block1Animation }; },
  'cinemagraphScroll': async () => { return { default: cinemagraphScroll }; },
  'datesGame': async () => { return { default: datesGame }; },
  'globalEventButton': async () => { return { default: globalEventButton }; },
  'hoverParentClass': async () => { return { default: hoverParentClass }; },
  'iNeverGame': async () => { return { default: iNeverGame }; },
  'loopingAnimation': async () => { return { default: loopingAnimation }; },
  'openByGlobalEvents': async () => { return { default: openByGlobalEvents }; },
  'playVideo': async () => { return { default: playVideo }; },
  'playlist': async () => { return { default: playlist }; },
  'playlistsCarousel': async () => { return { default: playlistsCarousel }; },
  'scrollTop': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/scrollTop.js'),
  'shareCurrentUrl': async () => { return { default: shareCurrentUrl }; },
  'sliderBlock': async () => await import( /* webpackMode: "lazy-once" */ '@/widgets/sliderBlock.js'),
  'spriteAnimation': async () => { return { default: spriteAnimation }; },
  'stopClickPropagation': async () => { return { default: stopClickPropagation }; }
};
